import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { computed } from "vue";
import { useTranslation } from "@/plugins/i18next/i18next";
import { buildMasterdataHelper } from "../factory";
export const MasterDisciplineFragment = gql `
  fragment _ on Discipline {
    id
    name
    status
    rank
    codename
  }
`;
export function useDisciplineHelper() {
    const { t } = useTranslation();
    function getDisciplines() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterDisciplines{
            disciplines {
              ${MasterDisciplineFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.disciplines) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, activeEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getDisciplines);
    const disciplinesTranslated = computed(() => {
        return activeEntities.value.map(discipline => ({
            id: discipline.id,
            name: discipline.name,
            i18n: t("common:discipline." + discipline.name),
            i18nShort: t("common:discipline.short." + discipline.name, t("common:discipline." + discipline.name))
        }));
    });
    /**
     * Returns disciplines supported by FEI
     */
    const feiDisciplines = computed(() => {
        return masterdataEntities.value
            .filter(x => [
            "dressage",
            "paradressage",
            "showjumping",
            "eventing",
            "endurance",
            "driving",
            "vaulting"
        ].includes(x.name))
            .map(discipline => ({
            id: discipline.id,
            name: discipline.name,
            i18n: t("common:discipline." + discipline.name)
        }));
    });
    /**
     * Returns disciplines supported by FEI
     */
    const feiDisciplineIds = computed(() => {
        return feiDisciplines.value.map(x => x.id);
    });
    function returnTranslatedDisciplineName(disciplineName) {
        return t("common:discipline." + disciplineName);
    }
    function getDisciplineNameFromMaster(id) {
        const x = masterdataEntities.value.find(y => y.id == id);
        return t("common:discipline." + x.name);
    }
    function getDisciplineCodenamesMapToId() {
        return masterdataEntities.value.reduce((mapping, d) => {
            mapping[d.codename] = d.id;
            return mapping;
        }, {});
    }
    return {
        allMasterDisciplines: masterdataEntities,
        masterDisciplines: activeEntities,
        getDisciplineFromMaster: getFromMasterdata,
        withMissingDisciplineSelect: addMissingSelectValue,
        disciplinesTranslated,
        feiDisciplines,
        feiDisciplineIds,
        returnTranslatedDisciplineName,
        getDisciplineNameFromMaster,
        getDisciplineCodenamesMapToId
    };
}
